const EducationData = [
  {
    school: "University of Waterloo",
    degree: "B.Sc. Mathematical Physics",
    text: [""],
    location: "Waterloo, ON, Canada",
    duration: "2019 - 2024",
    endDate: Date("April 31, 2024"),
  },
  {
    school: "K.R. Mangalam World School",
    degree: "High School Diploma",
    text: [""],
    location: "New Delhi, India",
    duration: "2007 - 2019",
    endDate: Date("April 31, 2019"),
  },
];

export default EducationData;
